import React from 'react'
import { BarChart3 } from 'lucide-react'

export function NoDataState() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] space-y-4">
      <div className="p-4 rounded-full bg-muted">
        <BarChart3 className="h-8 w-8 text-muted-foreground" />
      </div>
      <div className="text-center space-y-2">
        <h3 className="text-lg font-semibold">No Analytics Data Available</h3>
        <p className="text-muted-foreground max-w-md">
          This Instagram account doesn't have any processed analytics data yet. The analysis may still be in progress.
        </p>
      </div>
    </div>
  )
}

export default NoDataState


